export function userIsPro(user) {
  const plan = user.subscription.plan.name;
  return ["PRO", "ELITE", "ADMIN"].includes(plan);
}

export function userIsElite(user) {
  const plan = user.subscription.plan.name;
  return ["ELITE", "ADMIN"].includes(plan);
}
